import React from 'react'
import { Box } from '@material-ui/core'
import Avatar from '@material-ui/core/Avatar'
import ProfilePhoto from './ProfilePhoto'

export default function DrawerProfile() {
  return (
    <Box
      display="flex"
      justifyContent="Center"
      alignItems="center"
      height={100}
    >
      <Avatar component={ProfilePhoto} alt="flvyu's photo" />
    </Box>
  )
}
